module.exports = __webpack_public_path__ + "static/img/icon1.32bbee18.png";